var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.windowWidth >= 1320)?_c('MainMenuDesktop',{attrs:{"animation-enabled":_vm.animationEnabled,"routes":_vm.routes}}):_c('MainMenuMobile',{attrs:{"animation-enabled":_vm.animationEnabled,"routes":_vm.routes,"lock-scroll":true}})}
var staticRenderFns = []

export { render, staticRenderFns }